import React, { Component } from "react";
import "./App.css";
import "antd-mobile/dist/antd-mobile.css";
import { Router, Route } from "react-router-dom";
// 首页
import home from "./components/home/index.js";
// 搜索页
import Search from "./components/Search/index";
// 解忧人列表
import Person from "./components/WorryRelievingPerson/index";
// 解忧人详情
import PersonDetail from "./components/WorryRelievingPerson/PersonDetail";
// 我的问题
import Write from "./components/Writelitter/index";
// 我的邮箱
import Mymailbox from "./components/Mymailbox";
// 专家指南
import Guide from "./components/Guide";
import GuideDetail from "./components/GuideDetail";


// 回答问题
import Answer from "./components/Answer";
import createHistory from "history/createHashHistory";
const history = createHistory();
class App extends Component {
  render() {
    return (
      <div className="App">
        <Router history={history}>
          <Route
            render={() => {
              return (
                <div>
                  <Route exact path="/" component={home} />
                  <Route exact path="/search" component={Search} />
                  <Route exact path="/person" component={Person} />
                  <Route exact path="/persondetail" component={PersonDetail} />
                  <Route exact path="/writelitter" component={Write} />
                  <Route exact path="/mymailbox" component={Mymailbox} />
                  <Route exact path="/anwser" component={Answer} />
                  <Route exact path="/guide" component={Guide} />
                  <Route exact path="/guidedetail/:id?" component={GuideDetail} />
                </div>
              );
            }}
          />
        </Router>
      </div>
    );
  }
}

export default App;
